import(/* webpackMode: "eager" */ "/vercel/path0/app/wallet/page.tsx");
